module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_kimono-0f96e98ce627c60f4bf6b1ed6b063a4a.webp";